import React from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class ChartExpandModal extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    isOpen: this.props.openModal,
    chartName: this.props.chartName,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };
  closeModal = () => this.setState({ isOpen: false });
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              className="columnsModal"
              size="xl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Document</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <this.state.chartName
                  filters={this.props.filters}
                  isModal={true}
                  chartHeightClass={this.props.chartHeightClass}
                  showEllipsis={false}
                  bodyParams={this.props.bodyParams}
                />
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(connect(mapStateToProps)(ChartExpandModal));
